import { render, staticRenderFns } from "./landCardDetail.vue?vue&type=template&id=233ffb72&scoped=true"
import script from "./landCardDetail.vue?vue&type=script&lang=js"
export * from "./landCardDetail.vue?vue&type=script&lang=js"
import style0 from "./landCardDetail.vue?vue&type=style&index=0&id=233ffb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ffb72",
  null
  
)

export default component.exports